import React from 'react'
import './nav.css'
import {AiOutlineHome} from 'react-icons/ai'
import {AiOutlineUser} from 'react-icons/ai'
import {MdPlaylistAdd} from 'react-icons/md'
import {FaLaughSquint} from 'react-icons/fa'
import {BsCameraReels} from 'react-icons/bs'
import {MdOutlineUpcoming} from 'react-icons/md'
import {BiBook} from 'react-icons/bi'
import {RiServiceLine} from 'react-icons/ri'
import {BiMessageSquareDetail} from 'react-icons/bi'
import {MdWorkspacesFilled} from 'react-icons/md'
import {useState} from 'react'

const Nav = () => {
  const [activeNav,setActiveNav] = useState('#');
  return (
    <nav>
        <a href="#" onClick={() => setActiveNav('#')} className={activeNav === '#' ? 'active' : ''}><AiOutlineHome/></a>
        <a href="#about" onClick={() => setActiveNav('#about')} className={activeNav === '#about' ? 'active' : ''}><AiOutlineUser/></a>
        <a href="#playlists" onClick={() => setActiveNav('#playlists')} className={activeNav === '#playlists' ? 'active' : ''}><MdPlaylistAdd/></a>
        <a href="#memes" onClick={() => setActiveNav('#memes')} className={activeNav === '#memes' ? 'active' : ''}><FaLaughSquint/></a>
        <a href="#shorts" onClick={() => setActiveNav('#shorts')} className={activeNav === '#shorts' ? 'active' : ''}><BsCameraReels/></a>
        <a href="#upcoming" onClick={() => setActiveNav('#upcoming')} className={activeNav === '#upcoming' ? 'active' : ''}><MdOutlineUpcoming/></a>
        <a href="#contact" onClick={() => setActiveNav('#contact')} className={activeNav === '#contact' ? 'active' : ''}><BiMessageSquareDetail/></a>
    </nav>
  )
}

export default Nav